import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      class: "button",
      disabled: _ctx.desabilitar,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.exportToCSV(_ctx.json)))
    }, _toDisplayString(_ctx.textoBotao), 9, _hoisted_1)
  ]))
}